export default {
  en: {
    title: 'Network - visualisation',
    communityTitle: 'Network - {communityName} visualisation',
    pageHeader: 'Network',
    visualisationHeaderName: 'Visualisation',
    communityVisualisationHeaderName: '{communityName} visualisation',
    learnMore: 'Learn more',
    emptyTitle: 'You have not added any suppliers',
    emptySubtitle: 'Add a supplier to see them on the network visualisation',
    emptyCTA: 'Add a supplier',
    description:
      'Visualise all of your immediate first degree suppliers and anonymised nth degree suppliers beyond that.',
    complianceKey: 'Compliance key',
    filteredBy: 'Filtered by',
    resetFilters: 'Reset filters',
    compliancePercentage: 'Compliance:',
    incompleteAssessment: 'Assessment incomplete',
    unclaimed: 'Unclaimed supplier',
    searchOrg: 'Search organisations',
    closePreview: 'Clear selection',
    viewProfile: 'View profile',
    error: 'Failed to load network. Please try again.',
    nav: {
      visualisation: 'Visualisation',
      dataTable: 'Data table',
      yourSupplyChain: 'Your supply chain',
      yourSupplyChainDataTable: 'Your supply chain data table',
      communitySupplyChain: 'Community supply chain',
    },
    key: {
      '0': '0',
      '50': '50',
      '100': '100',
      title: 'Key',
      concentrationRisk: 'Concentration risk',
      potentialCR: '{0} potential risk | {0} potential risks',
      compliance: 'Compliance %',
      show: 'Show',
      hide: 'Hide',
      mint: '100%',
      blue: '70% - 99%',
      yellow: '50% - 69%',
      orange: '30% - 49%',
      red: '0% - 29%',
      community: 'Community member',
      communityMembers: '{0} community member | {0} community members',
    },
    nthPartyConnection: '{nth} party connection',
    nthPartyOnly: '{nth} party',
    nthParty: {
      '3': '{0} third-party supplier | {0} third-party suppliers',
      '4': '{0} fourth-party supplier | {0} fourth-party suppliers',
      '5': '{0} fifth-party supplier | {0} fifth-party suppliers',
      '6': '{0} sixth-party supplier | {0} sixth-party suppliers',
      '7': '{0} seventh-party supplier | {0} seventh-party suppliers',
      '8': '{0} eighth-party supplier | {0} eighth-party suppliers',
      '9': '{0} ninth-party supplier | {0} ninth-party suppliers',
      '10': '{0} tenth-party supplier | {0} tenth-party suppliers',
      '11': '{0} eleventh-party supplier | {0} eleventh-party suppliers',
      '12': '{0} twelfth-party supplier | {0} twelfth-party suppliers',
      '13': '{0} thirteenth-party supplier | {0} thirteenth-party suppliers',
      '14': '{0} fourteenth-party supplier | {0} fourteenth-party suppliers',
      '15': '{0} fifteenth-party supplier | {0} fifteenth-party suppliers',
      '16': '{0} sixteenth-party supplier | {0} sixteenth-party suppliers',
      '17': '{0} seventeenth-party supplier | {0} seventeenth-party suppliers',
      '18': '{0} eighteenth-party supplier | {0} eighteenth-party suppliers',
      '19': '{0} nineteenth-party supplier | {0} nineteenth-party suppliers',
      '20': '{0} twentieth-party supplier | {0} twentieth-party suppliers',
    },
    config: {
      network: 'Network visualisation',
      enableNetworkTitle: 'Enable network visualisation',
      enableNetworkDesc1:
        'By enabling visualisation, you will be able to see the names of all organisations within your supply chain, including 4th, 5th and 6th parties.',
      enableNetworkDesc2: 'Your clients will also be able to see the names of your suppliers.',
      fetchError: 'Failed to get network configuration.',
      updateError: 'Failed to update network configuration.',
      excludeSuppliersTitle: 'Exclude suppliers',
      excludeSuppliersDesc:
        'Select which suppliers you would like to exclude from the visualisation, the names of these suppliers will not be shared with your clients.',
      excludeSuppliersPlaceholder: 'Search...',
    },
    placeholder: {
      title: 'Visualise your supply chain network',
      description: {
        first:
          'By enabling visualisation, you will be able to see the names of all organisations within your supply chain, including 4th, 5th and 6th parties. Your clients will also be able to see the names of your suppliers.',
        second:
          'The Risk Ledger network visualisation allows all organisations to see the breadth and depth of their supply chain, identify concentration risk and begin to work together to Defend-as-One™.',
      },
      enable: 'Enable visualisation',
    },
    filters: {
      filter: 'Filter',
      title: 'Filter your network',
      criticality: 'Criticality',
      confidentiality: 'Confidentiality',
      pii: 'PII',
      labels: 'Labels',
      selectTag: 'Select a tag...',
      selectLabel: 'Select a label...',
      nthParty: 'Network depth',
      showing: 'Showing:',
      aToBSuppliers: '{a} to {b} party suppliers',
      aSuppliersOnly: '{a} party suppliers only',
      apply: 'Apply',
    },
    switch3d: 'See in 3D',
    performance: {
      title: 'Performance',
      density: 'Network map density',
      showRiskLedgerSuppliers: "Show Risk Ledger's suppliers",
      animations: 'Show animations',
    },
    ordinalNumber: '{number}{ordinal}',
    ordinals: {
      zero: 'n/a',
      one: 'st',
      two: 'nd',
      few: 'rd',
      many: 'n/a',
      other: 'th',
    },
    table: {
      title: 'Network - table view',
      headerName: 'Table view',
      emptyTitle: 'Organisations',
      emptyDescription: 'No organisations could be found',
      errorTitle: 'Organisations',
      errorDescription: 'Failed fetching organisations',
      entityName: 'Organisation',
      searchPlaceholder: 'Search organisations',
      isPotentialConcentrationRisk: 'Potential concentration risk',
      anonymisedSupplierCount: '{count} anonymised supplier | {count} anonymised suppliers',
      communityMember: 'Community member',
      filters: {
        name: 'Name',
        degree: 'Degree',
        numClients: 'No. of clients',
        clientNames: 'Client names',
        numSuppliers: 'No. of suppliers',
        supplierNames: 'Supplier names',
        potentialConcentrationRisk: 'Potential concentration risk',
        isRisk: 'Is potential concentration risk',
        isNotRisk: 'Is not potential concentration risk',
        sector: 'Sector',
        country: 'Location',
      },
      columns: {
        name: 'Organisation',
        degree: 'Degree',
        numClients: 'No. of clients',
        clientNames: 'Client names',
        numSuppliers: 'No. of suppliers',
        supplierNames: 'Supplier names',
        supplierNamesDesc: "Doesn't include anonymised suppliers",
        potentialConcentrationRisk: 'Potential concentration risk',
        sector: 'Sector',
        country: 'Location',
      },
      degrees: {
        nthParty: '{ordinal} party supplier',
      },
      export: 'Export',
      exportError: 'There was an error attempting to export the network data table',
      exportTitle: 'Network-Data-Table',
    },
    openRisk: 'Open risk',
    communityMember: 'Community member',
  },
};
